import type { DeviceAccess } from './Device';

export type ShareLevel = Exclude<DeviceAccess, 'owner'>;

export interface DeviceShare {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  level: ShareLevel;
  createdAt: string;
}

export interface PendingQrInvite {
  id: string;
  level: ShareLevel;
  expiresAt: string;
}

// Lo que se aceptó con un código QR: el mismo /join sirve para compartir una
// estación o un lote entero.
export type AcceptedInvite =
  | { kind: 'device'; deviceId: string; deviceName: string; ownerName: string; level: ShareLevel }
  | { kind: 'lot'; lotId: string; lotName: string; ownerName: string; level: ShareLevel };

// A dónde ir con lo que se escaneó: el QR trae el link completo
// (…/join?token=…); si no es una URL, el texto es el token. /join acepta
// tanto el código de una estación como el de un lote.
export function joinPathForScan(decodedText: string): string {
  try {
    const token = new URL(decodedText).searchParams.get('token');
    if (token) return `/join?token=${encodeURIComponent(token)}`;
  } catch {
    // No era una URL completa.
  }
  return `/join?token=${encodeURIComponent(decodedText)}`;
}
